import { isEmpty } from '@ember/utils'
import type { NormalizedInterval } from 'date-fns'
import type { QuizScoresHistoryDataItem } from 'teacher-ui-client/components/giraffe/charts/quiz-scores/history'
import type { SchoolScope, StudentsScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type StudentEventsService from 'teacher-ui-client/services/student-events'

export interface QuizScoresHistoryResponse {
  quizzes_history: {
    student_id: number
    avg_score: number
    quizzes_taken: number
    total_attempts: number
  }[]
}

export async function quizScoresHistory(
  this: StudentEventsService,
  product: LegacyProductRex,
  statsScope: SchoolScope | StudentsScope,
  period: NormalizedInterval,
): Promise<Nullable<QuizScoresHistoryDataItem[]>> {
  if (isEmpty(statsScope.ids)) return null

  const url = this.buildUrl('quizzes_history', product, statsScope)
  const query = this.buildQuery(statsScope, period)

  const data = await this.fetchData<QuizScoresHistoryResponse>(url, query)
  if (!data) return null

  const { quizzes_history } = data
  if (quizzes_history.length === 0) return null

  return quizzes_history
}
